<template>
  <div class="page-shell business-page">
    <div class="topbar business-page__topbar">
      <div class="page-title business-page__title">
        <h1><span class="title-icon">🤝</span>商业合作申请</h1>
        <p>管理商业合作申请</p>
      </div>
    </div>

    <div class="card business-list-card">
      <div class="search-bar business-search-bar">
        <input v-model.trim="draftFilters.applyNo" type="text" placeholder="申请编号">
        <input v-model.trim="draftFilters.phone" type="text" placeholder="手机号">
        <button class="btn btn-outline business-search-btn" @click="applySearch">
          <span>🔍</span>
          <span>查询</span>
        </button>
      </div>

      <div class="table-wrap business-table-wrap">
        <table>
          <thead>
            <tr>
              <th>申请编号</th>
              <th>申请人</th>
              <th>手机号</th>
              <th>身份类型</th>
              <th>提交时间</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="7" class="table-empty">加载中...</td>
            </tr>
            <tr v-else-if="!list.length">
              <td colspan="7" class="table-empty">暂无申请记录</td>
            </tr>
            <template v-else>
              <tr v-for="item in list" :key="item.id">
                <td class="business-num">{{ item.applyNo }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.phone }}</td>
                <td>{{ item.roleTypeText }}</td>
                <td>{{ item.createdAt }}</td>
                <td><span :class="statusClass(item.status)">{{ item.statusText }}</span></td>
                <td>
                  <button class="btn btn-sm btn-outline business-detail-btn" @click="openDetail(item)">查看详情</button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="business-pagination">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { cooperationApplicationList } from '../../../api/userMG'

export default {
  name: 'business-applications-index',
  data() {
    return {
      loading: false,
      list: [],
      filters: { applyNo: '', phone: '' },
      draftFilters: { applyNo: '', phone: '' },
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0,
        lastPage: 1
      }
    }
  },
  created() {
    const routeQuery = this.$route.query || {}
    const page = Number(routeQuery.page) > 0 ? Number(routeQuery.page) : 1

    this.filters = {
      applyNo: routeQuery.apply_no || '',
      phone: routeQuery.phone || ''
    }
    this.draftFilters = Object.assign({}, this.filters)
    this.pagination.currentPage = page

    this.loadList(page)
  },
  methods: {
    async loadList(page) {
      this.loading = true

      const targetPage = page || this.pagination.currentPage
      const params = {
        page: targetPage,
        per_page: this.pagination.pageSize
      }

      if (this.filters.applyNo) {
        params.apply_no = this.filters.applyNo
      }

      if (this.filters.phone) {
        params.phone = this.filters.phone
      }

      try {
        const res = await cooperationApplicationList(params)

        if (!this.isListSuccess(res)) {
          this.list = []
          this.pagination.total = 0
          this.$message.error(this.getErrorMessage(res, '商业合作申请列表加载失败'))
          return
        }

        const meta = res.meta || {}

        this.list = Array.isArray(res.data) ? res.data.map(item => this.normalizeItem(item)) : []
        this.pagination.currentPage = Number(meta.current_page) || targetPage
        this.pagination.pageSize = Number(meta.per_page) || this.pagination.pageSize
        this.pagination.total = Number(meta.total) || 0
        this.pagination.lastPage = Number(meta.last_page) || 1
      } catch (error) {
        this.list = []
        this.pagination.total = 0
        this.$message.error(this.getErrorMessage(error, '商业合作申请列表加载失败'))
      } finally {
        this.loading = false
      }
    },
    normalizeItem(item) {
      return {
        id: item.id,
        applyNo: item.apply_no,
        name: item.name,
        phone: item.phone,
        roleTypeText: item.role_type_text || item.role_type || '—',
        createdAt: item.created_at || '—',
        status: item.status,
        statusText: item.status_text || this.statusText(item.status)
      }
    },
    isListSuccess(res) {
      return !!(res && typeof res === 'object' && Array.isArray(res.data) && res.meta && !res.message && !res.detail && !res.errors)
    },
    statusText(status) {
      return {
        pending: '待处理',
        processed: '已处理'
      }[status] || status
    },
    statusClass(status) {
      return {
        status: true,
        'status-pending': status === 'pending',
        'status-approved': status === 'processed',
        'status-rejected': status === 'rejected'
      }
    },
    getErrorMessage(error, fallback) {
      if (!error) return fallback
      if (typeof error === 'string') return error
      if (error.message) return error.message
      if (error.detail) return error.detail
      if (error.errors) {
        const firstKey = Object.keys(error.errors)[0]
        const firstError = firstKey ? error.errors[firstKey] : ''

        if (Array.isArray(firstError)) {
          return firstError[0] || fallback
        }

        return firstError || fallback
      }

      return fallback
    },
    applySearch() {
      this.filters = Object.assign({}, this.draftFilters)
      this.pagination.currentPage = 1
      this.loadList(1)
    },
    handlePageChange(page) {
      this.loadList(page)
    },
    openDetail(item) {
      this.$router.push({
        path: '/applications/business/' + item.id,
        query: {
          page: String(this.pagination.currentPage),
          apply_no: this.filters.applyNo,
          phone: this.filters.phone
        }
      })
    }
  }
}
</script>

<style scoped>
.business-page {
  gap: 18px;
}

.business-page__topbar {
  min-height: 70px;
  margin: -20px -20px 0;
  padding: 18px 24px 20px;
  background: #e9eef5;
}

.business-page__title h1 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  line-height: 1.2;
}

.business-page__title p {
  margin-top: 10px;
  font-size: 13px;
  color: #334155;
}

.title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  font-size: 18px;
}

.business-list-card {
  padding: 22px 22px 20px;
  border-radius: 16px;
}

.business-search-bar {
  align-items: center;
  margin-bottom: 14px;
}

.business-search-bar input {
  width: 180px;
  min-width: 180px;
}

.business-search-btn {
  min-width: 78px;
  padding: 8px 14px;
}

.business-table-wrap {
  border-radius: 12px;
}

.business-num {
  color: #0f172a;
  font-weight: 700;
}

.business-detail-btn {
  min-width: 70px;
  padding-left: 10px;
  padding-right: 10px;
}

.business-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.table-empty {
  padding: 24px 12px;
  text-align: center;
  color: var(--cog-text-secondary);
}

@media (max-width: 768px) {
  .business-page__topbar {
    margin: -16px -16px 0;
    padding: 16px;
  }

  .business-list-card {
    padding: 16px;
  }

  .business-search-bar input,
  .business-search-btn {
    width: 100%;
    min-width: 0;
  }

  .business-pagination {
    justify-content: center;
    overflow-x: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/applications/business/index.vue